import { ContractorStatus, Location } from '@umss/shared/data-access';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { BaseEntityDto } from '../common/base-entity.dto';

export interface ContractorAdminDto extends BaseEntityDto {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  profilePicture: string;
  profilePictureUrl?: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  status: ContractorStatus;
  registeredDate: string; // DateTime as ISO string
  lastActiveDate?: string | null; // DateTime as ISO string
  totalShiftsCompleted: number;
  totalEarnings: number;
  activeShiftsCount: number;
  hasPendingDocuments: boolean;
  primaryLocation?: Location;
}
